module.exports = __webpack_public_path__ + "media/images/individual-benefit-1-cf25ff8c40062f210887902d5df36545.svg";